import React from 'react';
import { FlowerIcon } from 'lucide-react';
import { BalloonIcon } from './BalloonIcon';
import type { Kind } from '../../data/site';
type KindTagProps = {
  kind: Kind;
  label: string;
  tone?: 'light' | 'dark';
};
export function KindTag({
  kind,
  label,
  tone = 'light'
}: KindTagProps) {
  const toneCls = tone === 'light' ? 'bg-white/95 text-mauve-deep' : 'bg-petal text-mauve-deep';
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium ${toneCls}`} data-id="element-336" data-mp="2whh4bvh9v1xk">
      {kind !== 'balloons' ? <FlowerIcon className="h-3 w-3" aria-hidden="true" data-id="element-337" data-mp="2rg1mecae5bje" /> : null}
      {kind !== 'flowers' ? <BalloonIcon className="h-3 w-3" data-id="element-338" data-mp="2nidl8ri3umj2" /> : null}
      {label}
    </span>;
}